import React, { useEffect } from 'react';
import { Provider } from 'mobx-react';
import rootStore from '@/stores';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from '@/router';

import { throttle } from '@/utils/index'
import './static/css/index.scss';

const fn = throttle(() => {
  rootStore.common.setWindowSize(document.documentElement.clientWidth)
})

function App() {
  useEffect(() => {
    fn()
    window.addEventListener('resize', fn)

    return () => {
      window.removeEventListener('resize', fn)
    }
  }, [])

  return (
    <Provider store={rootStore}>
      <Router>
        <Routes />
      </Router>
    </Provider>
  );
}

export default App;
